import { distinctNoteBrowsingHistory } from "~/client/components/search/distinctNoteBrowsingHistory";
import type { UserType } from "~/client/components/shared/UserAvatarWithPopup";
import { useGetNoteBrowsingHistoryQuery } from "~/client/generated/schema";
import type { Connection, ConnectionWithTotalCount } from "~/client/utils/relay";
import { emptyConnection } from "~/client/utils/relay";

export type NoteBrowsingHistoryEntry = Readonly<{
  path: string;
  title: string;

  contributors: ConnectionWithTotalCount<UserType>;
}>;

export type NoteBrowsingHistoryNode = Readonly<{
  note: NoteBrowsingHistoryEntry;
}>;

const MAX_DISPLAYED_HISTORY = 8;

const coerceConnection = (history) =>
  history ? (history as Connection<NoteBrowsingHistoryNode>) : emptyConnection<NoteBrowsingHistoryNode>();

export const useNoteBrowsingHistory = () => {
  const { data, loading } = useGetNoteBrowsingHistoryQuery({ variables: { first: MAX_DISPLAYED_HISTORY * 2 } });

  const entries = distinctNoteBrowsingHistory(coerceConnection(data?.noteBrowsingHistories), MAX_DISPLAYED_HISTORY);

  return { entries, isLoading: loading };
};
